import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PoweroffOutlined } from "@ant-design/icons";

const Header = ({ headerClass }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userEmail, setUserEmail] = useState("");

  const getUserDetails = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    setUserEmail(user.email)
  }
  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  useEffect(()=>{
    getUserDetails();
  },[])

  const getHeaderTitle = () => {
    switch (location.pathname) {
      case "/data-curation":
        return "Curate Files";
      case "/company-curation":
        return "Curate Files";
      case "/master-data":
        return "Master Data";
      case "/fdf-master":
        return "FDF Master Data";
      case "/curate-product":
        return "Curate Name";
      case "/chapter-config":
        return "Chapter Config";
      case '/users':
        return "Users";
      case '/config-product':
        return "Configure Products";
      case '/verification':
        return "Verify Products";
      case '/validate':
        return "Key Validation";
      case '/validation-history':
        return "Validation History";
      default:
        if (location.pathname.startsWith('/verification/')) {
          return "Verify Products";
        }
        return "Curation";
    }
  };

  return (
    <React.Fragment>
<header id="page-topbar" className={headerClass}>
  <div
    className="layout-width navbar-header"
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 24px", 
    }}
  >
    <div
      className="card-title "
      style={{ fontWeight: 600 }}
    >
      {getHeaderTitle()}
    </div>
    <div className="">
      <span style={{margin: "20px", color: "blue", fontWeight: "bold"}}>{userEmail}</span>
      <button
        type="button"
        style={{
          padding: "7px",
          backgroundColor: "red",
          color: "white",
          border: "none",
          borderRadius: "4px", 
          cursor: "pointer",
        }}
        onClick={handleLogout}
        title="Logout"
      >
        <PoweroffOutlined style={{ fontSize: "18px" }} />
      </button>
    </div>
  </div>
</header>

    </React.Fragment>
  );
};

export default Header;
